// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"eebe80d3","565":"9c67c285","595":"8a7b9da4","688":"bf462a77","783":"200e62f9","906":"1e8aaffb"}[chunkId] + ".chunk.js";
};